export const sustainabilitySubMenu = [
  {
    id: 1,
    link: "#our-proposition",
    label: "Our proposition",
  },
  {
    id: 2,
    link: "#our-commitment",
    label: "Our commitment",
  },
  {
    id: 3,
    link: "#creating-sustainable-value",
    label: "Create sustainable value",
  },
  // {
  //   id: 4,
  //   link: "#empowering-our-people",
  //   label: "Empowering our people",
  // },
  {
    id: 5,
    link: "#governance",
    label: "Governance",
  },
];
